export default "__VITE_ASSET__tECTM8iV__"